import { modes, CustomEvents } from '@powerplay/common';
import { CorePhases } from '../types';
import { CameraStates } from '@powerplay/camera-system';
import { PhaseManager } from './PhaseManager';
import { RequestLogTypes } from '@powerplay/request-system';
import { SettingsTypes } from '@powerplay/settings';
import { LoadingStatsTypes } from '@powerplay/stats-system';
export class PhaseFinalResultsManager extends PhaseManager {
    cameraManager;
    inputsManager;
    fpsManager;
    requestManager;
    settings;
    gameStats;
    trainingManager;
    activeSkip = !modes.isTrainingMode();
    constructor(cameraManager, inputsManager, fpsManager, requestManager, settings, gameStats, trainingManager) {
        super(cameraManager, inputsManager, fpsManager, requestManager);
        this.cameraManager = cameraManager;
        this.inputsManager = inputsManager;
        this.fpsManager = fpsManager;
        this.requestManager = requestManager;
        this.settings = settings;
        this.gameStats = gameStats;
        this.trainingManager = trainingManager;
        this.PHASE_NAME = 'FINAL RESULTS';
        this.skippable = false;
        this.phaseNumber = CorePhases.finalResults;
        this.framesToWaitForSkipAfterPhaseStarts = 20;
    }
    startPhase() {
        if (this.requestManager.TUTORIAL_ID === undefined)
            this.fpsManager.checkRaiseQuality();
        if (this.settings.compareLastSavedToNew())
            this.settings.saveValues(true);
        const settingsStartQuality = this.settings.startQualityValue;
        const settingsQuality = this.settings.getSetting(SettingsTypes.quality);
        console.log('start phase final phase');
        const dataEnd = {
            fps_min_start: this.fpsManager.getMinimalFpsByQuality(settingsStartQuality),
            fps_avg_start: this.fpsManager.getAverageFpsByQuality(settingsStartQuality),
            fps_min_end: this.fpsManager.getMinimalFpsByQuality(settingsQuality),
            fps_avg_end: this.fpsManager.getAverageFpsByQuality(settingsQuality),
            exited: this.gameStats.wasExitedGame() ? 1 : 0,
            quality_start: settingsStartQuality,
            quality_end: settingsQuality,
            controls_type: this.settings.getSetting(SettingsTypes.controlsType),
            bonus_data: JSON.stringify(this.gameStats.getDisciplineDataToLog()),
            loading_time: this.gameStats.getDiffLoadingStats(LoadingStatsTypes.endTime, LoadingStatsTypes.startTime),
            loadingPart1FirstInit: this.gameStats.getDiffLoadingStats(LoadingStatsTypes.partFirstInit, LoadingStatsTypes.startTime),
            loadingPart2InitRequest: this.gameStats.getDiffLoadingStats(LoadingStatsTypes.partInitRequest, LoadingStatsTypes.partFirstInit),
            loadingPart3BeforeLoader: this.gameStats.getDiffLoadingStats(LoadingStatsTypes.partBeforeLoader, LoadingStatsTypes.partInitRequest),
            loadingPart4LoadingAssets: this.gameStats.getDiffLoadingStats(LoadingStatsTypes.partLoadingAssets, LoadingStatsTypes.partBeforeLoader),
            loadingPart5SecondInit: this.gameStats.getDiffLoadingStats(LoadingStatsTypes.partSecondInit, LoadingStatsTypes.partLoadingAssets),
            loadingPart6ParamsRequest: this.gameStats.getDiffLoadingStats(LoadingStatsTypes.endTime, LoadingStatsTypes.partSecondInit)
        };
        if (this.trainingManager.retry > 0) {
            dataEnd.loading_time = 0;
            dataEnd.loadingPart1FirstInit = 0;
            dataEnd.loadingPart2InitRequest = 0;
            dataEnd.loadingPart3BeforeLoader = 0;
            dataEnd.loadingPart4LoadingAssets = 0;
            dataEnd.loadingPart5SecondInit = 0;
            dataEnd.loadingPart6ParamsRequest = 0;
        }
        this.requestManager.sendLogRequest(RequestLogTypes.end, dataEnd);
        this.gameStats.setExitedGame(true);
        super.startPhase();
        this.cameraManager.setState(CameraStates.table);
        this.cameraManager.playTween(true);
        if (modes.isTrainingMode()) {
            window.dispatchEvent(new CustomEvent(CustomEvents.startFinalTrainingPhase));
        }
        else {
            window.dispatchEvent(new CustomEvent(CustomEvents.startFinalStandingsPhase));
        }
    }
    skipPhase() {
        if (!this.activeSkip)
            return;
        super.skipPhase();
    }
    enableSkip() {
        if (!modes.isTrainingMode())
            this.skippable = true;
    }
}
//# sourceMappingURL=PhaseFinalResultsManager.js.map